module.exports = __webpack_public_path__ + "media/images/covid/icons/temperature-0751fe920ccc2d3cac824d0a707c57cc.png";